import React from 'react';
import ABSBackTop from '../ABSBackTop';

export interface IABSBackTopContainerProps {
  containerIndex?: number;
  shareContent?: React.ReactNode;
}
class ABSBackTopContainer extends React.Component<IABSBackTopContainerProps> {
  static defaultProps = {
    containerIndex: 1
  };

  getDom = () => {
    const { containerIndex } = this.props;
    const container = document.getElementsByClassName('scrollbar-container');
    if (container.length > 0) {
      return container[containerIndex!] as HTMLElement;
    }
    return null;
  };

  render() {
    const { children, shareContent } = this.props;
    return (
      <div className="abs-backtop-container">
        {children}
        <ABSBackTop dom={this.getDom()} shareContent={shareContent} />
      </div>
    );
  }
}

export default ABSBackTopContainer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSBackTopContainer/index.tsx